export default [
  {
    path: "/blood-store",
    name: "blood-store",
    component: () => import("@/views/bloodBank/bloodStore.vue"),
  },
  {
    path: "/blood-transfusions",
    name: "blood-transfusions",
    component: () => import("@/views/bloodBank/bloodTransfusions.vue"),
  },
  {
    path: "/blood-compatibilities/:blood_transfusion_id/:patient_name/:patient_abo/:patient_rh/:isSho",
    name: "blood-compatibilities",
    component: () => import("@/views/bloodBank/bloodCompatibilities.vue"),
  },
];
